var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCostPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 67.5,
    r: 66.8351,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.32979
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.75,
    cy: 67.5,
    r: 61.8351,
    fill: "#F2F9F1",
    stroke: "#82C275",
    strokeWidth: 1.32979
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.4886,
    y: 46.8739,
    width: 57.0215,
    height: 43.195,
    fill: "white",
    stroke: "#82C275",
    strokeWidth: 2.05538
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8438 59.3848H54.4591",
    stroke: "#82C275",
    strokeWidth: 2.05538
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8438 68H63.0745",
    stroke: "#82C275",
    strokeWidth: 2.05538
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8438 76.6155H63.0745",
    stroke: "#82C275",
    strokeWidth: 2.05538
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0273 58.2063V78.3176",
    stroke: "#82C275",
    strokeWidth: 1.64103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5986 61.8628H78.7425C77.8939 61.8628 77.0801 62.1999 76.4801 62.7999C75.8801 63.3999 75.543 64.2138 75.543 65.0623C75.543 65.9109 75.8801 66.7247 76.4801 67.3247C77.0801 67.9247 77.8939 68.2618 78.7425 68.2618H83.3132C84.1618 68.2618 84.9756 68.5989 85.5756 69.199C86.1757 69.799 86.5128 70.6128 86.5128 71.4614C86.5128 72.3099 86.1757 73.1237 85.5756 73.7238C84.9756 74.3238 84.1618 74.6609 83.3132 74.6609H75.543",
    stroke: "#82C275",
    strokeWidth: 1.64103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostPlus);
export default __webpack_public_path__ + "static/media/CostPlus.0642238a0227f221cf72ae5513ff09d4.svg";
export { ForwardRef as ReactComponent };